import { __extends } from "tslib";
import { CustomError } from "./CustomError.mjs";
var RetryAfterError = /** @class */ (function (_super) {
    __extends(RetryAfterError, _super);
    function RetryAfterError(after) {
        var _this = _super.call(this, "Need to retry after ".concat(after, " ms")) || this;
        _this._retryAt = Date.now() + after;
        return _this;
    }
    Object.defineProperty(RetryAfterError.prototype, "retryAt", {
        get: function () {
            return this._retryAt;
        },
        enumerable: false,
        configurable: true
    });
    return RetryAfterError;
}(CustomError));
export { RetryAfterError };
